// src/components/Dashboard/EditEmployee.js
import React, { useState, useEffect } from 'react';
import { db } from '../../firebase/firebase';
import { useNavigate, useParams } from 'react-router-dom';
import { doc, getDoc, updateDoc } from "firebase/firestore";

const EditEmployee = () => {
  const { id } = useParams();
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmployee = async () => {
      const docRef = doc(db, 'employees', id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setFullName(data.full_name);
        setEmail(data.email);
      }
    };
    fetchEmployee();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const docRef = doc(db, 'employees', id);
    await updateDoc(docRef, {
      full_name: fullName,
      email: email,
    });
    navigate('/dashboard'); // Navigate back to the dashboard
  };

  return (
    <div>
      <h2>Edit Employee</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Full Name</label>
          <input
            type="text"
            className="form-control"
            placeholder="Full Name"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            className="form-control"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <button type="submit" className="btn btn-primary">Save Changes</button>
      </form>
    </div>
  ) 
};

export default EditEmployee;
